<template>
    <div class="card-box-small dashboard-box card-box-small-banner border-radius-8 border-0">
        <a
            :href="linkUrl"
            class="d-block h-100 overflow-hidden border-radius-8"
            target="_blank"
            rel="noopener noreferrer"
        >
            <div class="card-bg d-flex justify-content-between align-items-center" :style="{
                backgroundImage: `url(${imageUrl})`,
                backgroundColor: backgroundColor,
                backgroundSize:  backgroundSize,
                backgroundPosition: backgroundPosition
            }">
                <div v-if="$slots.default" :class="['card-content', 'p-3', defaultSlotClass]" :style="{
                    maxWidth: maxWidth
                }">
                    <slot />
                </div>
            </div>
        </a>
    </div>
</template>

<style scoped>
.card-box-small {
    a {
        text-decoration: none;
        color: inherit;
    }
}
.card-bg {
    height: 100%;
    display: flex;
    background-repeat: no-repeat;
}
.card-content {
    flex: 1;
    max-width: 60%;
    color: $color-white;
}
</style>
<script>
export default {
    props: {
        imageUrl: {
            type: String,
            default: ''
        },
        linkUrl: {
            type: String,
            default: '/'
        },
        backgroundColor: {
            type: String,
            default: '#fff'
        },
        backgroundSize: {
            type: String,
            default: 'cover'
        },
        backgroundPosition: {
            type: String,
            default: 'bottom right'
        },
        maxWidth: {
            type: String,
            default: '100%'
        },
        defaultSlotClass: {
            type: String,
            default: "",
        },
    }
}
</script>
